// export const baseUrl: string = process.env.REACT_APP_BASE_URL || "UNKNOWN BASE URL";
// export const redirectUrl: string = process.env.REACT_APP_REDIRECT_URL || "UNKNOWN REDIRECT URL";

export const ContactActivityTypes = {
  emailContactActitityTypeId: "ed72e93c-1e83-41cf-bb65-7ff11e60ab12",
  phoneContactActitityTypeId: "954bdb8b-f4a1-45f7-91c5-274be1879162",
  scheduleContactActitityTypeId: "8bee0b58-cc9d-472d-a6b2-fecb84f7b8f5",
  textContactActivityTypeId: "0a60e517-11d4-4a2a-b39b-9c1c914352c7",
  noteContactActivityTypeId: "72fb295c-6840-45a3-8832-dc2b1cf1deae",
  reminderContactActivityTypeId: "0ccaf1c4-d646-4f77-a162-4cabc57b8acb",
  taskContactActivityTypeId: "42dab673-3e2f-45ae-92ff-606a9ae27bab",
  logContactActivityTypeId: "TODO",
};

export const BusinessTypes = {
  bhph: "451829ca-9a0f-4639-9105-32fd18b21e7f",
  retail: "c33b0f61-7906-4662-a881-aa19e5bb2f9a",
  finance: "656f80b1-93cf-4672-adda-16487814484b"
};

export const ServiceUserId = "d662bce1-5e24-4f59-b9e9-2934caa2de2e";
export const NiadaAdministrator = "3b04060f-8cb4-4573-942a-88b20016ac16";

export const ScheduleStatuses = {
  missedId: "8399c21b-ad11-4ffb-b093-9c1f3eb00cdb",
  completedId: "aba4f2fa-8ebc-40dc-b752-adc38455133a",
  pending: "1d537cae-7b16-48fd-aba1-d16af9a452cc",
};

export const Roles = {
  funder: '0081417a-e474-4cef-95a5-0365dcfe1708',
  salesManager: 'cf462515-9570-4e98-a4f4-09fe668bcb6f',
  chiefSalesOfficer: '3d006743-b916-47a3-b6f0-265b4ed2c06c',
  underwriter: 'be92f02a-676e-4297-a48b-337f8c926e00',
  salesperson: '330a8946-264f-4c8b-92cb-423ca4c87b16',
  underwriterManager: 'c8d83e75-36e5-45b7-8dce-46f29855a4cd',
  bdcRepresentative: 'f61546c0-cbaa-43b3-972b-5ed9aec24764',
  admin: '7010add5-1acf-4aee-ab66-63b07fbca60e',
  investigator: '1551dd4b-3ec5-42df-a02f-8da7c0727020',
  regionalDirector: 'd95bc282-3877-4f95-83ac-bc60d2c6b8f2',
  investigatorManager: '5ab4851a-1cce-4bbf-b086-f65446d2d9a7',
  fundingManager: '7d5dd47f-0c54-4283-9b8c-f891fbe53805',
  svpOfSales: '08ce65d1-b2ee-49e8-a838-ac141a43e1bc'
}

export const GlobalStatuses = {
  applicationStatusId: '141e8275-8215-40e6-a4f2-40852f5f76f8'
}

export const OrganizationIds = {
  bdc: 'cdf7e0a4-038c-49ed-8c1c-685b9c1d1850',
  region: '42a8555d-8612-4493-9664-75eb8a2c4235',
  store: '619905cc-6d66-42de-95a3-0ff41739f2fe'
};

// TODO Think about how to make this dynamic. 
// This is currently being used for the count summaries on the home page
export const contactStatuses = {
  application: '141e8275-8215-40e6-a4f2-40852f5f76f8',
  bad: 'd42b7e7c-374c-496e-8bc3-90e76c5bdb43',
  up: '8c4a08de-6a77-464b-a811-c36aa270087a',
  delivered: '265bf0bc-1a2b-4257-b211-ce003b5416c8',
  lost: '47732268-6d83-405e-a9d8-db1c0e639483',
  new: 'cc083d1c-f072-4d69-85cb-e4e288e3db56',
  active: 'e3c744b1-c07c-4b14-aecf-fd050fbcf320',
  appointment: 'da9994b6-41a0-40cd-83e0-dbef1aa6bebe',
  exceptions: 'a2886247-b6d4-4fbd-806d-842899715be4',
  unassigned: '7dd9816c-226c-4d73-b461-edf8c9131a70',
  leads: 'f5edd40d-9d99-44c2-aa9a-57b36d59b5a6',
  allAppointments: 'ad530a5a-cd45-4bd3-97a8-3a1c08044963'
};

export const permissions = {
  clients: 'F5CED465-ABB9-49B6-84FD-9F1083AFBAA3',
  users: '9D69DF14-0C22-415C-9D9F-AD02E5D31D09'
}

export const DpgReportStatuses = {
  new: 'cf039362-dfe8-4864-9fd9-9b9070e4f27d',
  inProgress: '102edfb0-fc1a-4c0d-9c8e-da662959a733',
  submitted: 'dfc2e17c-15d5-4eb3-8eca-fc510a06bc16',
  locked: '519cdae2-1e0d-497a-93e7-c1086cb91520'
}